// removed by extract-text-webpack-plugin
module.exports = {"IconSet":"IconSet---2P9f-","IconPicker":"IconPicker---25i6t","IconPickerRow":"IconPickerRow---2VkxL"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/Customize/Styling/IconPicker/style.styl
// module id = esK+
// module chunks = 89